Office.onReady(async () => await registerSw());

async function registerSw() {
  if ("serviceWorker" in navigator) {
    try {
      const registration = await navigator.serviceWorker.register("service-worker.js");

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;

        if (installingWorker == null) {
          return;
        }

        installingWorker.addEventListener.onStateChange = async () => {
          if (installingWorker.state === "installed") {
            if (navigator.serviceWorker.controller) {
              console.log("New update available.");
              location.reload();
            }
          }
        };
      };
    } catch (err) {
      console.error("SW register error: ", err);
    }
  }
}
